import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Card, Col, Collapse, Row, Tabs } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import CustomBreadcrumb from 'src/components/CustomBreadcrumb'
import * as api from 'src/configs/API'
import BASE_CONFIG from 'src/configs/base'
import { SEO } from 'src/components/SEO'
import { useRouter } from 'next/router'

const { Panel } = Collapse
const { TabPane } = Tabs
const RenderItem = ({ item }) => {
	return (
		<Row
			key={item?.id}
			style={{
				borderBottom: '1px dashed #B5B5C3',
				padding: 10,
			}}
		>
			<Col span={24}>
				<Collapse
					bordered={false}
					ghost
					expandIcon={({ isActive }) =>
						isActive ? (
							<div
								style={{
									width: 23,
									height: 24,
									background: '#CC0000',
									borderRadius: 4,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<MinusOutlined style={{ color: 'white' }} />
							</div>
						) : (
							<PlusOutlined style={{ color: '#181C32' }} />
						)
					}
				>
					<Panel
						header={
							<span
								style={{
									fontWeight: 600,
									fontSize: 16,
									color: '#181C32',
								}}
							>
								{item?.Question}
							</span>
						}
					>
						<span
							style={{
								textAlign: 'justify',
								fontWeight: 500,
								fontSize: 14,
								color: '#5E6278',
								whiteSpace: 'pre-line',
							}}
						>
							{item?.Answer}
						</span>
					</Panel>
				</Collapse>
			</Col>
		</Row>
	)
}
const FAQ = () => {
	const [selectedKey, setSelectedKey] = useState('top10')
	const [loading, setLoading] = useState(false)
	const [listTop10FAQ, setListTop10FAQ] = useState([])
	const [listFAQ, setListFAQ] = useState([])
	const getDataPAQ = () => {
		setLoading(true)
		axios
			.get(api.default.API_GET_FAQ)
			.then((res) => {
				setListTop10FAQ(res?.data?.ListTop10?.filter((o) => o.IsActive === true))
				setListFAQ(res?.data?.ListData?.filter((o) => o.IsActive === true))
				setLoading(false)
			})
			.catch((err) => {
				console.log(err)
			})
	}
	useEffect(() => {
		getDataPAQ()
	}, [])

	return (
		<React.Fragment>
			<SEO
				data={{
					title: `Hỗ trợ | ${BASE_CONFIG.SLOGAN}`,
					description: 'Liên hệ với 247Express qua Hotline 1900 6980 hoặc Email: info@247express.vn để được tư vấn dịch vụ chuyển phát phù hợp và các giải pháp hỗ trợ khác.',
					keywords: '247Express, 247, express, nhanh hơn bạn nghĩ',
					url: BASE_CONFIG.PAGE_URL + useRouter().asPath,
				}}
			/>
			<div style={{ paddingTop: 30 }}>
				<CustomBreadcrumb />
			</div>
			<Card
				className="card-item-ho-tro"
				style={{
					background: '#FFFFFF',
					boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
					borderRadius: 12,
				}}
			>
				<Tabs defaultActiveKey={selectedKey} onChange={(key) => setSelectedKey(key)}>
					<TabPane
						tab={
							<span
								style={{
									fontWeight: 600,
									fontSize: 20,
									color: selectedKey == 'top10' ? '#CC0000' : '#B5B5C3',
								}}
							>
								Top 10 câu hỏi thường gặp
							</span>
						}
						key="top10"
					>
						{listTop10FAQ?.map((item, index) => {
							return <RenderItem key={`topfaq_${index}`} item={item} />
						})}
					</TabPane>
					<TabPane
						tab={
							<span
								style={{
									fontWeight: 600,
									fontSize: 20,
									color: selectedKey == 'getall' ? '#CC0000' : '#B5B5C3',
								}}
							>
								Danh mục câu hỏi
							</span>
						}
						key="getall"
					>
						{listFAQ?.map((item, index) => {
							return <RenderItem key={`listfaq_${index}`} item={item} />
						})}
					</TabPane>
				</Tabs>
			</Card>
		</React.Fragment>
	)
}

export default FAQ
